module.exports = __webpack_public_path__ + "static/media/98.d42c0039.jpg";